import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-shared-process-list',
  templateUrl: './shared-process-list.component.html',
  styleUrls: ['./shared-process-list.component.scss']
})
export class SharedProcessListComponent implements OnInit {

  private processListId: string;
  submiting: boolean = true;
  processList: any

  constructor(
    route: ActivatedRoute,
    private router: Router,
    private http: HttpService,
    private errorReport: ErrorReportService,
  ) {

    if (route.snapshot.params.id) {
      localStorage.setItem('redirectProcessListId', route.snapshot.params.id);
      this.processListId = route.snapshot.params.id;
    }

    const subject = new Subject<any>();
    subject.subscribe(({ trigger }: any) => {
      this.submiting = (trigger === 'pre');
    })
    this.http.setLoadingIndicator(subject);

  }

  ngOnInit(): void {

    this.http.get('process_list:get_by_id', { id: this.processListId })
      .subscribe(
        (result: any) => {
          // console.log('PROCESS', result)
          this.processList = result.data
        },
        (err: any) => this.errorReport.showMessage(err)
      )
  }

  goto() {
    this.router.navigate(['/', 'customer']);
  }

}
